import { useCallback, useState } from 'react';

import { ModalAuthState } from '../types';

interface ModalAuthHook {
  modalAuthState: ModalAuthState;
  setModalAuthState: (newModalAuthState: ModalAuthState) => void;
  modalAuthIsOpen: boolean;
}

// This hook is used to track the modal auth state. Which is used to determine if the user is in the modal auth state or not.
export const useModalAuth = (): ModalAuthHook => {
  const [modalAuthState, setModalAuthState] = useState<ModalAuthState>(ModalAuthState.CLOSED);

  const modalAuthIsOpen = modalAuthState !== ModalAuthState.CLOSED;

  const handleSetModalAuthState = useCallback((newModalAuthState: ModalAuthState) => {
    // TODO: handle some log here to track the modal auth state would be nice.
    setModalAuthState(newModalAuthState);
  }, []);

  return { modalAuthState, setModalAuthState: handleSetModalAuthState, modalAuthIsOpen };
};
